var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguageIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 25.109 25.008",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15655",
    "data-name": "Path 15655",
    d: "M26.461,10.931a10.645,10.645,0,0,0-.715-1.786,12.688,12.688,0,0,0-9.824-7.056L15.476,2H13.511l-.536.089A12.307,12.307,0,0,0,3.15,9.145a10.645,10.645,0,0,0-.715,1.786,12.176,12.176,0,0,0,0,7.145,10.645,10.645,0,0,0,.715,1.786,12.688,12.688,0,0,0,9.824,7.056l.536.089h1.965l.536-.089a12.688,12.688,0,0,0,9.824-7.056,10.645,10.645,0,0,0,.715-1.786,12.945,12.945,0,0,0-.089-7.145ZM23.782,9.145H19.138a18.163,18.163,0,0,0-2.144-5.091,10.846,10.846,0,0,1,6.788,5.091ZM18.066,14.5a16.166,16.166,0,0,1-.357,3.573h-6.52a19.221,19.221,0,0,1,0-7.145h6.52A16.166,16.166,0,0,1,18.066,14.5Zm-.715,5.359a15.128,15.128,0,0,1-2.679,5.359H14.4a15.128,15.128,0,0,1-2.679-5.359ZM11.635,9.145a15.128,15.128,0,0,1,2.679-5.359h.268a15.128,15.128,0,0,1,2.679,5.359Zm.357-5.091A18.163,18.163,0,0,0,9.849,9.145H5.2A10.846,10.846,0,0,1,11.992,4.054ZM3.776,14.5A9.716,9.716,0,0,1,4.4,10.931H9.492a19.221,19.221,0,0,0,0,7.145H4.4A9.716,9.716,0,0,1,3.776,14.5ZM5.2,19.863H9.849a18.163,18.163,0,0,0,2.144,5.091A10.846,10.846,0,0,1,5.2,19.863Zm11.789,5.091a18.163,18.163,0,0,0,2.144-5.091h4.644A10.846,10.846,0,0,1,16.994,24.954Zm2.59-6.877a24.051,24.051,0,0,0,.268-3.573,24.051,24.051,0,0,0-.268-3.573h5a10.887,10.887,0,0,1,0,7.145Z",
    transform: "translate(-1.9 -2)",
    fill: "#fe6036"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageIcon);
export default __webpack_public_path__ + "static/media/LanguageIcon.364de2cf2e2981bcc4e1377c80b1897f.svg";
export { ForwardRef as ReactComponent };